import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    function onClick1(item, itemIndex, e) {
        this.toggleItem(e, item);
    }
    function onClick2(item, itemIndex, subItem, subItemIndex, e) {
        this.toggleItem(e, subItem);
    }
    function repeatSubItem3(item, itemIndex, subItem, subItemIndex) {
        return React.createElement('div', {
            'className': 'add-stone-lir',
            'onClick': onClick2.bind(this, item, itemIndex, subItem, subItemIndex),
            'key': subItem.id
        }, React.createElement('div', { 'className': 'radio-ring' }, subItem.checked ? React.createElement('div', {
            'className': 'radio-check',
            'key': '1002'
        }) : null), React.createElement('span', { 'className': 'add-stone-lir-text' }, subItem.displayText || subItem.value));
    }
    function repeatItem4(item, itemIndex) {
        return React.createElement('div', {
            'className': 'add-stone-lir-wrapper',
            'key': item.id
        }, React.createElement('div', {
            'className': 'add-stone-lir',
            'onClick': onClick1.bind(this, item, itemIndex)
        }, React.createElement('div', { 'className': 'radio-ring' }, !_.size(item.items || item.values) && this.isChecked(item) ? React.createElement('div', {
            'className': 'radio-check',
            'key': '256'
        }) : null, _.size(item.items || item.values) && item.expanded ? React.createElement('div', {
            'className': 'radio-arrow-open',
            'key': '364'
        }) : null, _.size(item.items || item.values) && !item.expanded ? React.createElement('div', {
            'className': 'radio-arrow-closed',
            'key': '469'
        }) : null), React.createElement('span', { 'className': 'add-stone-lir-text' }, item.displayText || item.value || item.name)), _.size(item.items || item.values) && item.expanded ? React.createElement.apply(this, [
            'div',
            {
                'className': 'add-stone-sub-lir',
                'key': '692'
            },
            _.map(item.items || item.values, repeatSubItem3.bind(this, item, itemIndex))
        ]) : null);
    }
    return React.createElement.apply(this, [
        'div',
        { 'className': this.state.containerClass },
        _.map(this.props.filterItems, repeatItem4.bind(this))
    ]);
}